import gql from 'graphql-tag';
import { CORE_EVENT_TYPE_FIELDS, EVENT_TYPE_FILTER_FIELDS } from '../fragments';

export const CREATE_EVENT_TYPE = gql`
  mutation CreateEventType($input: CreateEventTypeInput!) {
    createEventType(input: $input) {
      ...CoreEventTypeFields
      ...EventTypeFilterFields
    }
  }
  ${EVENT_TYPE_FILTER_FIELDS}
  ${CORE_EVENT_TYPE_FIELDS}
`;

export const UPDATE_EVENT_TYPE = gql`
  mutation UpdateEventType($input: UpdateEventTypeInput!) {
    updateEventType(input: $input) {
      ...CoreEventTypeFields
      ...EventTypeFilterFields
    }
  }
  ${EVENT_TYPE_FILTER_FIELDS}
  ${CORE_EVENT_TYPE_FIELDS}
`;

export const DELETE_EVENT_TYPE = gql`
  mutation DeleteEventType($id: ID!) {
    deleteEventType (
      id: $id
    ) {
      id
    }
  }
`;

export const RESTORE_EVENT_TYPE = gql`
  mutation RestoreEventType($id: ID!) {
    restoreEventType (
      id: $id
    ) {
      ...CoreEventTypeFields
      ...EventTypeFilterFields
    }
  }
  ${EVENT_TYPE_FILTER_FIELDS}
  ${CORE_EVENT_TYPE_FIELDS}
`;
